import { api, baseUrl } from '../../api';

export const allAvailableVendorApi = async () => {
    const result = await api.get(`${baseUrl}/admin/settings/available-vendor`);
    return result.data;
};